import React, { Fragment, useEffect, useState } from "react";
import {
  Button,
  Grid,
  Alert,
  Autocomplete,
  TextField,
  Box,
  Typography,
  IconButton,
  Divider,
} from "@mui/material/";
import { NavLink } from "react-router-dom";
import {
  Work,
  AccountBox,
  Inventory2,
  PersonAdd,
  Loop,
  AccessTime,
  Check,
  Close,
  Person2TwoTone,
  Person3Outlined,
  People,
} from "@mui/icons-material";
import { CustomIcons, statusConfig } from "../../Components/helpers/Helpers";
import { CustomIconsPlusText } from "../../Components/Common/Design/CustomIconsPlusText";
import Swal from "sweetalert2";
import api from "../../api/axios";
import { COLORS, STYLES } from "./muiStyles/muiStyles";
import { CustomButtonPlusIcon } from "../../Components/Common/Design/CustomButtonPlusIcon";

const InfoSection = ({
  lawyerData,
  clientData,
  dataCase,
  contactConditionIfExist,
  lawyersList,
  setUpdatedCase,
  updatedCase,
}) => {
  const [changeLawyer, setChangeLawyer] = useState(false);
  const [selectedLawyer, setSelectedLawyer] = useState(lawyerData || null);
  const [newLawyer, setNewLawyer] = useState(null);
  const [inputLawyerValue, setInputLawyerValue] = useState("");

  useEffect(() => setSelectedLawyer(lawyerData || null), [lawyerData]);

  const handleConfirmNewLawyer = async () => {
    if (!newLawyer) return;

    // 1. Confirmación
    const confirm = await Swal.fire({
      title: "¿Guardar nuevo abogado?",
      text: `¿Deseas asignar a ${newLawyer.name} a este caso?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Sí, guardar",
      cancelButtonText: "Cancelar",
      confirmButtonColor: "#1ab394",
      cancelButtonColor: "#d33",
      reverseButtons: true,
    });

    if (!confirm.isConfirmed) return;

    try {
      // 2. Loading real
      Swal.fire({
        title: "Guardando...",
        text: "Procesando la información.",
        allowOutsideClick: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      console.log(dataCase?.id, newLawyer.id);

      const res = await api.post("cases/update", {
        id: dataCase?.id,
        user_id: newLawyer.id,
      });

      console.log(res, "res");

      Swal.close();

      // 4. Éxito
      await Swal.fire({
        title: "Abogado actualizado",
        text: "El abogado ha sido asignado correctamente.",
        icon: "success",
        confirmButtonColor: "#1ab394",
        timer: 1000,
      });

      // Limpiar estados
      setSelectedLawyer(newLawyer);
      // setChangeLawyer(false);
      // setNewLawyer(null);
      // setInputLawyerValue("");
      setUpdatedCase(!updatedCase);
    } catch (error) {
      console.error(error);
      Swal.close();

      Swal.fire({
        title: "Error",
        text: "No se pudo guardar el abogado. Intenta nuevamente.",
        icon: "error",
        confirmButtonColor: "#d33",
      });
    }
  };

  const handleCancel = () => {
    setNewLawyer(null);
    setInputLawyerValue("");
    setChangeLawyer(false);
  };

  const dataLawyer = [
    {
      label: "Abogado:",
      value: (
        <>
          {selectedLawyer?.id ? (
            <NavLink
              to={`/usuarios/ver?id=${selectedLawyer.id}`}
              style={{ textDecoration: "none" }}>
              <Box
                component="span"
                sx={{ fontWeight: 700, color: COLORS.lawyer, fontSize: 14 }}>
                {selectedLawyer.name}
              </Box>
            </NavLink>
          ) : (
            <Box component="span" sx={{ color: COLORS.subtleText }}>
              Sin asignar
            </Box>
          )}
        </>
      ),
    },
    { label: "Empresa:", value: selectedLawyer?.company || "-" },
    { label: "Asociación:", value: selectedLawyer?.association || "-" },
  ];

  console.log(clientData);
  const dataClient = [
    {
      label: "Cliente:",
      value: clientData?.name && (
        <NavLink
          style={{ textDecoration: "none", color: COLORS.client }}
          to={`/clientes/ver?id=${clientData.id}`}>
          <Box component="span" sx={{ fontWeight: 700, color: COLORS.client }}>
            {clientData.name}
          </Box>
        </NavLink>
      ),
    },
    { label: "Documento:", value: clientData?.document || "-" },
    { label: "Teléfono:", value: clientData?.phone || "-" },
    { label: "Email:", value: clientData?.email || "-" },
    { label: "Dirección:", value: clientData?.address || "-" },
    { label: "Provincia:", value: clientData?.province || "-" },
    { label: "Código postal:", value: clientData?.postalcode || "-" },
  ];

  return (
    <Box
      sx={{
        // background: COLORS.pageBg,
        p: "10px",
        width: "100%",
      }}>
      {/* Alerta */}
      {contactConditionIfExist && (
        <Alert
          variant={
            contactConditionIfExist.includes("multiples contactos")
              ? "outlined"
              : "filled"
          }
          severity={
            contactConditionIfExist.includes("multiples contactos")
              ? "error"
              : "info"
          }
          sx={{
            borderRadius: "6px",
            mb: 3,
            boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
          }}>
          {contactConditionIfExist}
        </Alert>
      )}

      {/* Header */}
      <Grid
        container
        alignItems="center"
        sx={{
          mb: 1,
          textAlign: "center",
          padding: "10px",
          background: "white",
          borderRadius: "4px",
        }}>
        {/* IZQUIERDA — TIPO DE CASO */}
        <Grid item xs={4}>
          <Box sx={{ textAlign: "left" }}>
            <Box
              component="span"
              sx={{ color: COLORS.subtleText, fontSize: 14, fontWeight: 600 }}>
              {dataCase?.case_type_name}
            </Box>
          </Box>
        </Grid>

        {/* CENTRO — EXPEDIENTE */}
        <Grid item xs={4}>
          <Box
            sx={{
              textAlign: "center",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}>
            <Box
              component="span"
              sx={{
                fontWeight: 600,
                fontSize: 16,
                letterSpacing: 0.5,
                mr: "10px",
              }}>
              EXPEDIENTE #{String(dataCase?.case_id || "-").toUpperCase()}
            </Box>

            <IconButton size="small">
              <Inventory2 />
            </IconButton>
          </Box>
        </Grid>

        {/* DERECHA — ÚLTIMA ACTUALIZACIÓN */}
        <Grid item xs={4}>
          <Box sx={{ textAlign: "right" }}>
            <Box
              sx={{
                display: "flex",
                gap: 1,
                alignItems: "center",
                justifyContent: "flex-end",
              }}>
              <Box
                component="span"
                variant="span"
                sx={{
                  fontSize: 12,
                  color: COLORS.subtleText,
                  fontWeight: "600",
                }}>
                Última actualización
              </Box>
              <CustomIcons icon={AccessTime} width="15px" height="15px" />
              <Box component="span" sx={{ fontSize: 12 }}>
                {dataCase?.last_update || "-"}
              </Box>
            </Box>
          </Box>
        </Grid>
      </Grid>

      {/* Estado */}
      <Box
        sx={{
          ...STYLES.sectionCard,
          mb: 1,
          display: "flex",
          gap: 2,
          alignItems: "center",
          justifyContent: "center",
        }}>
        {/* <Box component="span" sx={{ fontWeight: 700 }}>Estado</Box> */}
        <Box sx={{ ml: 1 }}>
          {(() => {
            const state = dataCase?.task?.status;
            const config = statusConfig[state];
            return (
              <CustomIconsPlusText
                icon={config?.icon || Close}
                severity={config?.severity}
                variant={config?.variant}
                text={
                  config
                    ? config.text(dataCase?.flow?.status_name).toUpperCase()
                    : "No iniciado"
                }
              />
            );
          })()}
        </Box>
      </Box>

      {/* Abogado + Cliente */}
      <Grid container spacing={1}>
        {/* Abogado */}
        <Grid item xs={12} md={6}>
          <Box
            sx={{
              ...STYLES.sectionCard,
              height: "-webkit-fill-available",
            }}>
            <Grid container alignItems="center">
              <Grid
                item
                xs={3}
                sx={{ justifyContent: "center", textAlign: "center" }}>
                <Box
                  sx={{
                    ...STYLES.avatarWrapper,
                    background: COLORS.lawyerBg,
                    margin: "auto",
                    mb: "10px",
                  }}>
                  <Work sx={{ color: COLORS.lawyer, fontSize: 70 }} />
                </Box>
                <Box
                  sx={{
                    ...STYLES.pill,
                    background: COLORS.lawyer,
                    text: "auto",
                  }}>
                  Abogado
                </Box>
              </Grid>

              <Grid item xs={9}>
                {/* Header */}
                <Box
                  sx={{ display: "flex", justifyContent: "right", mb: "5px" }}>
                  <Box sx={{ display: "flex", gap: 1 }}>
                    <CustomButtonPlusIcon
                      variant="outlined"
                      color="info"
                      position="start"
                      size="small"
                      icon={People}
                      handleFunction={() => {
                        setChangeLawyer((prev) => !prev);
                        setNewLawyer(selectedLawyer || null);
                      }}
                      text={"Editar Abogado"}
                    />
                  </Box>
                </Box>
                <Divider />
                {/* Campos */}
                <Grid container sx={{ mt: 1 }}>
                  {dataLawyer.map((item, index) => (
                    <Grid
                      key={index}
                      item
                      xs={12}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        marginBottom: "7px",
                      }}>
                      {/* LABEL */}
                      <Box
                        sx={{
                          width: "25%", // ajustable
                          display: "flex",
                          alignItems: "center",
                        }}>
                        <Box
                          component="span"
                          sx={{
                            color: COLORS.subtleText,
                            fontSize: 14,
                            fontWeight: 600,
                            whiteSpace: "nowrap",
                          }}>
                          {item.label.replace(":", "")}
                        </Box>
                      </Box>

                      {/* VALUE / AUTOCOMPLETE */}
                      <Box
                        sx={{
                          width: "75%",
                          display: "flex",
                          alignItems: "center",
                        }}>
                        {index === 0 && changeLawyer ? (
                          <Box
                            sx={{
                              ...STYLES.autoWrapper,
                              height: "20px",
                              alignItems: "center",
                              display: "flex",
                              gap: "4px",
                              width: "100%",
                            }}>
                            <Autocomplete
                              options={lawyersList || []}
                              value={newLawyer}
                              inputValue={inputLawyerValue}
                              onChange={(e, v) => setNewLawyer(v)}
                              onInputChange={(e, v) => setInputLawyerValue(v)}
                              getOptionLabel={(o) =>
                                o
                                  ? `${o.name || ""} ${o.surname || ""}`.trim()
                                  : ""
                              }
                              sx={{ flex: 1 }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  placeholder="Buscar abogado"
                                  size="small"
                                  sx={{
                                    "& .MuiInputBase-root": {
                                      height: "20px",
                                      fontSize: 12,
                                    },
                                    "& .MuiOutlinedInput-notchedOutline": {
                                      border: "none",
                                    },
                                  }}
                                />
                              )}
                            />

                            <IconButton
                              onClick={handleCancel}
                              sx={{
                                width: 20,
                                height: 20,
                                bgcolor: "#fff",
                                borderRadius: "4px",
                                border: "1px solid rgba(0,0,0,0.1)",
                                p: 0,
                                "& .MuiSvgIcon-root": { fontSize: 14 },
                              }}>
                              <Close sx={{ color: "#d32f2f" }} />
                            </IconButton>

                            <IconButton
                              disabled={!newLawyer}
                              onClick={handleConfirmNewLawyer}
                              sx={{
                                width: 20,
                                height: 20,
                                bgcolor: newLawyer
                                  ? COLORS.primary
                                  : "rgba(0,0,0,0.05)",
                                borderRadius: "4px",
                                p: 0,
                                "& .MuiSvgIcon-root": { fontSize: 14 },
                                color: newLawyer ? "#fff" : "#999",
                              }}>
                              <Check />
                            </IconButton>
                          </Box>
                        ) : (
                          <Box
                            component="span"
                            sx={{
                              color: COLORS.subtleText,
                              fontSize: 14,
                              fontWeight: 600,
                            }}>
                            {item.value}
                          </Box>
                        )}
                      </Box>
                    </Grid>
                  ))}
                </Grid>
              </Grid>
            </Grid>
          </Box>
        </Grid>

        {/* Cliente */}
        <Grid item xs={12} md={6}>
          <Box sx={STYLES.sectionCard}>
            <Grid container alignItems="center">
              <Grid
                item
                xs={3}
                sx={{ justifyContent: "center", textAlign: "center" }}>
                <Box
                  sx={{
                    ...STYLES.avatarWrapper,
                    background: COLORS.clientBg,
                    margin: "auto",
                    mb: "10px",
                  }}>
                  <AccountBox sx={{ color: COLORS.client, fontSize: 70 }} />
                </Box>
                <Box
                  sx={{
                    ...STYLES.pill,
                    background: COLORS.client,
                    textAlign: "center",
                  }}>
                  Cliente
                </Box>
              </Grid>

              <Grid item xs={9}>
                <Grid container>
                  {dataClient.map((item, index) => (
                    <Grid
                      key={index}
                      item
                      xs={12}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        marginBottom: "7px",
                      }}>
                      {/* LABEL */}
                      <Box
                        sx={{
                          width: "25%",
                          display: "flex",
                          alignItems: "center",
                        }}>
                        <Box
                          component="span"
                          sx={{
                            color: COLORS.subtleText,
                            fontSize: 14,
                            fontWeight: 600,
                            whiteSpace: "nowrap",
                          }}>
                          {item.label.replace(":", "")}
                        </Box>
                      </Box>

                      {/* VALUE */}
                      <Box
                        sx={{
                          width: "75%",
                          display: "flex",
                          alignItems: "center",
                        }}>
                        {item.value ? (
                          <Box
                            component="span"
                            sx={{
                              color: COLORS.subtleText,
                              fontSize: 14,
                            }}>
                            {item.value}
                          </Box>
                        ) : (
                          <Box
                            component="span"
                            sx={{
                              color: COLORS.client,
                              fontSize: 14,
                            }}>
                            {" "}
                            Información no disponible
                          </Box>
                        )}
                      </Box>
                    </Grid>
                  ))}
                </Grid>
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default InfoSection;
